/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CodeStub } from './CodeStub'
import { DocumentGroup } from './DocumentGroup'
import { FormLayout } from './FormLayout'
import { FormTemplateLayout } from './FormTemplateLayout'

import { decodeStringOrArrayBuffer} from './ModelHelper'
export class FormTemplate {
  constructor(json: JSON | any) {
    Object.assign(this as FormTemplate, json, json.rawTemplateLayout ? { rawTemplateLayout: decodeStringOrArrayBuffer(json.rawTemplateLayout) } : {})
  }

  id?: string
  rev?: string
  /**
   * hard delete (unix epoch in ms) timestamp of the object
   */
  deletionDate?: number
  layout?: FormLayout
  templateLayout?: FormTemplateLayout
  rawTemplateLayout?: ArrayBuffer
  name?: string
  guid?: string
  group?: DocumentGroup
  descr?: string
  disabled?: string
  specialty?: CodeStub
  author?: string
  formInstancePreferredLocation?: string
  keyboardShortcut?: string
  shortReport?: string
  mediumReport?: string
  longReport?: string
  reports?: Array<string>
  tags?: Array<CodeStub>
  layoutAttachmentId?: string
  templateLayoutAttachmentId?: string
}
